import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";

export default function CoDatePicker({
  control,
  name,
  sx = {},
  disableFuture = false,
  minDate = null,
  maxDate = null,
  disabled = false,
  value = null,
  format,
  large = false,
  rules = {}, // Validation rules for react-hook-form
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        defaultValue={value ? dayjs(value) : null} // Set default value
        rules={rules} // Pass validation rules
        render={({ field }) => (
          <DatePicker
            {...field} // Spread field properties from React Hook Form
            format={format}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: large ? "50px !important" : "44px !important",
                fontSize: large ? "16px" : "14px",
              },
              "& .MuiOutlinedInput-root.Mui-disabled": {
                backgroundColor: "#F2F2F2 !important", // Ensure disabled background color is applied
                pointerEvents: "none", // Prevent interactions
              },
              "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#F2F2F2 !important",
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000 !important", // Ensures text remains visible
              },
              ...sx, // Spread additional custom styles
            }}
            disableFuture={disableFuture}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            onChange={(newValue) => {
              field.onChange(newValue ? dayjs(newValue) : null); // Ensure the value is always a Day.js object
            }}
            value={field.value ? dayjs(field.value) : null} // Controlled value
          />
        )}
      />
    </LocalizationProvider>
  );
}
